module.exports = __webpack_public_path__ + "img/地图.c8d0ece2.png";